import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { APP_INITIALIZER, Injector, NgModule } from "@angular/core";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { DelonACLModule } from "@delon/acl";
import { DelonCacheModule } from "@delon/cache";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
//#region http Interceptors
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from "@angular/common/http";
// main ui lib
// import { NgDragDropModule } from 'ng-drag-drop';
import { SharedModule } from "@root/shared/shared.module";
import { SortablejsModule } from "ngx-sortablejs-ivy";
// custom module
import { AppRouteModule } from "@root/app-route.module";
import { PagesModule } from "@root/router/pages.module";
// import { ComponentModule } from '@root/component/component.module';
// main component
import { AppComponent } from "@root/app.component";

/** 配置 angular i18n **/
import { InjectorService } from "./injector.service";

//#region Register Language
import { registerLocaleData } from "@angular/common";
import zh from "@angular/common/locales/zh";
//#region Startup Service
import { StartupService } from "./startup.service";
import { MockInterceptor } from "@root/shared/interceptor/mock.interceptor";
import { AuthInterceptor } from "@root/shared/interceptor/auth.interceptor";
import { EmptyParamsInterceptor } from "@root/shared/interceptor/empty-params.interceptor";
//#region Const Config
// import { GLOBAL_CONFIG_TOKEN, GlobalConfig } from '@root/config';
import { NZ_CONFIG, NzConfig } from "ng-zorro-antd/core/config";
import { ErrorInterceptor } from "./shared/interceptor/error.interceptor";
// import { RequestInterceptor } from "@root/shared/interceptor/request.interceptor";

//#region 错误监控
import { ErrorHandler } from "@angular/core";
// import * as fundebug from "fundebug-javascript";

// fundebug['apikey'] = "7f669a09b57aa3880c4418aa7c6e78d3eba2d1aca9e2a9dfb72b38b2a2aabce2";

// 定义FundebugErrorHandler
// export class FundebugErrorHandler implements ErrorHandler {
//   handleError(err: any): void {
//     fundebug.notifyError(err);
//   }
// }

//#endregion

registerLocaleData(zh);

//#endregion
export function StartupServiceFactory(startupService: StartupService): () => Promise<void> {
  return () => startupService.load();
}

const APPINIT_PROVIDES = [
  StartupService,
  {
    provide: APP_INITIALIZER,
    useFactory: StartupServiceFactory,
    deps: [StartupService],
    multi: true,
  },
];
//#endregion
// import { PiwikInterceptor } from '@root/shared/interceptor/piwik.interceptor';
const INTERCEPTOR_PROVIDERS = [
  { provide: HTTP_INTERCEPTORS, useClass: MockInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: EmptyParamsInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  // { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true }
  // { provide: HTTP_INTERCEPTORS, useClass: PiwikInterceptor, multi: true }
];
//#endregion

//#region Translate Loader
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "/app/assets/i18n/", ".json");
}

const LOADER = {
  provide: TranslateLoader,
  useFactory: createTranslateLoader,
  deps: [HttpClient],
};
//#endregion
// const CONFIG_PROVIDERS = [{ provide: GLOBAL_CONFIG_TOKEN, useValue: GlobalConfig }];
const ngZorroConfig: NzConfig = {
  pagination: {
    nzSize: "small",
  },
  notification: {
    nzMaxStack: 1,
  },
};
const NG_CONFIG_PROVIDERS = [{ provide: NZ_CONFIG, useValue: ngZorroConfig }];
//#endregion

const isInternationalDomain = () => {
  return (
    location.href.indexOf("localhost") !== -1 ||
    location.href.indexOf("g.test") !== -1 ||
    location.href.indexOf("hostex.io") !== -1
  );
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    DelonCacheModule,
    DelonACLModule.forRoot(),
    TranslateModule.forRoot({
      loader: LOADER,
      defaultLanguage: isInternationalDomain() ? "en" : "cn",
    }),
    // NgDragDropModule.forRoot(),
    SortablejsModule.forRoot({ animation: 150 }),

    SharedModule,
    PagesModule,
    AppRouteModule,
  ],
  providers: [
    // environment.production ? null : {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: MockInterceptor,
    //   multi: true
    // },
    // AlainConfigService,
    ...INTERCEPTOR_PROVIDERS,
    ...APPINIT_PROVIDES,
    // ...CONFIG_PROVIDERS,
    ...NG_CONFIG_PROVIDERS,
    // {provide: ErrorHandler, useClass: FundebugErrorHandler}
    // ...tokens,
    // { provide: NZ_I18N, useValue: zh_CN }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private injector: Injector) {
    InjectorService.injector = this.injector;
  }
}
